(function() {
  "use strict";
  var root = document.querySelector("[data-quiz-newsletter-states]");
  if (!root || root.dataset.quizMounted) return;
  root.dataset.quizMounted = "true";
  var form = root.querySelector("[data-quiz-newsletter-form]");
  var card = root.querySelector('[data-banner-card="subscribe"]');
  var entry = root.querySelector("[data-quiz-entry]");
  var panel = root.querySelector("[data-quiz-status]");
  var art = root.querySelector("[data-quiz-state-art]");
  var decor = card.querySelector(".results-banner__decor");
  var check = root.querySelector("[data-quiz-check]");
  var claim = root.querySelector("[data-quiz-claim]");
  var message = root.querySelector("[data-quiz-state-message]");
  var note = form.querySelector("[data-subscribe-note]");
  var submit = form.querySelector('[type="submit"]');
  var receiptKey = "wynch_club_enrollment_receipt_v1";
  var uiKey = "wynch_article_club_confirmed_ui_v1";
  var contextKey = "wynch_quiz_newsletter_context_v1";
  var experiment = "quiz_newsletter_background_v1";
  var palette = ["orange", "olive", "blue", "yellow"];
  var generation = 0;
  var countdownTimer;
  var state = "entry", busy = false, checking = false, timer, locale = root.dataset.locale.indexOf("en") === 0 ? "en" : "de";
  var context = read(contextKey) || {};
  if (context.locale === "en" || context.locale === "de") locale = context.locale;
  var ownedToken = continuation();
  var events = read(experiment + "_events") || {};
  var cohort = read(experiment);
  if (!cohort || palette.indexOf(cohort.variant) < 0) {
    cohort = { variant: palette[Math.floor(Math.random() * palette.length)], assigned: Date.now() };
    save(experiment, cohort);
  }
  var params = new URLSearchParams(location.search);
  var qa = params.get("quiz_bg");
  var qaState = params.get("quiz_state");
  var testing = palette.indexOf(qa) >= 0 || ["entry", "pending", "confirmed", "claimed"].indexOf(qaState) >= 0;
  var variant = palette.indexOf(qa) >= 0 ? qa : cohort.variant;
  root.dataset.quizBg = variant;
  var copy = {
    en: {
      pendingTitle: "Confirm your email",
      pendingCopy: "Check your inbox and confirm your email to unlock your Cava and 30% off your first order.",
      confirmedTitle: "Your welcome gifts are ready",
      confirmedCopy: "Your email is confirmed. Add your complimentary Cava and personal 30% voucher to your cart.",
      claimedTitle: "Your gifts are in your cart",
      claimedCopy: "Enjoy your Cava on us and 30% off your first order. Use the same email at checkout.",
      check: "Send email again",
      countdown: "Send again in {s}",
      resent: "Confirmation email requested again. Please check your inbox.",
      resendError: "We couldn\u2019t resend the email. Please try again.",
      change: "Use another email",
      checking: "Checking\u2026",
      waiting: "We\u2019re still waiting for your email confirmation. Check your inbox and spam folder.",
      error: "We couldn\u2019t check your confirmation. Please try again.",
      sending: "Sending\u2026",
      sendError: "We couldn\u2019t send your request. Please try again.",
      invalid: "Enter a valid email address.",
      claim: "Claim My Cava",
      claiming: "Adding your gifts\u2026",
      open: "Open my cart",
      unavailable: "Your gifts could not be added. Please try again.",
      cooldown: "Please wait a moment before trying again.",
      dailyLimit: "Daily limit reached. Please try again tomorrow.",
      linkFailed: "We could not link your taste profile to this email yet. Please try again."
    },
    de: {
      pendingTitle: "Best\xE4tige deine E-Mail",
      pendingCopy: "Pr\xFCfe dein Postfach und best\xE4tige deine E-Mail f\xFCr deine Cava und 30 % auf deine erste Bestellung.",
      confirmedTitle: "Deine Willkommensgeschenke sind bereit",
      confirmedCopy: "Deine E-Mail ist best\xE4tigt. Lege deine kostenlose Cava und deinen pers\xF6nlichen 30-%-Gutschein in den Warenkorb.",
      claimedTitle: "Deine Geschenke sind im Warenkorb",
      claimedCopy: "Freu dich auf deine Cava und 30 % auf deine erste Bestellung. Verwende dieselbe E-Mail an der Kasse.",
      check: "E-Mail erneut senden",
      countdown: "Erneut senden in {s}",
      resent: "Die Best\xE4tigungs-E-Mail wurde erneut angefordert. Bitte pr\xFCfe dein Postfach.",
      resendError: "Die E-Mail konnte nicht erneut gesendet werden. Bitte versuche es erneut.",
      change: "Andere E-Mail verwenden",
      checking: "Wird gepr\xFCft\u2026",
      waiting: "Wir warten noch auf deine E-Mail-Best\xE4tigung. Pr\xFCfe dein Postfach und den Spam-Ordner.",
      error: "Die Best\xE4tigung konnte nicht gepr\xFCft werden. Bitte versuche es erneut.",
      sending: "Wird gesendet\u2026",
      sendError: "Deine Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.",
      invalid: "Gib eine g\xFCltige E-Mail-Adresse ein.",
      claim: "Meine Cava sichern",
      claiming: "Deine Geschenke werden hinzugef\xFCgt\u2026",
      open: "Warenkorb \xF6ffnen",
      unavailable: "Deine Geschenke konnten nicht hinzugef\xFCgt werden. Bitte versuche es erneut.",
      cooldown: "Einen Moment bitte, dann erneut versuchen.",
      dailyLimit: "Tageslimit erreicht. Bitte morgen erneut versuchen.",
      linkFailed: "Wir konnten dein Geschmacksprofil noch nicht mit dieser E-Mail verbinden. Bitte versuche es erneut."
    }
  };
  function read(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || "null");
    } catch (_) {
      return null;
    }
  }
  function save(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_) {
    }
  }
  function text() {
    return copy[locale];
  }
  function allowed() {
    return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function track(stage) {
    if (testing || !allowed()) return;
    var slot = variant + ":" + stage + ":" + (stage === "view" ? "visitor" : context.started || "visitor");
    if (events[slot]) return;
    var payload = { experiment_id: experiment, variant, stage, locale, surface: "quiz_results", theme_id: root.dataset.previewTheme };
    if (!Shopify.analytics || typeof Shopify.analytics.publish !== "function") return;
    events[slot] = true;
    Promise.resolve(Shopify.analytics.publish("wynch_quiz_newsletter_experiment_v1", payload)).then(function() {
      events[slot] = true;
      save(experiment + "_events", events);
    }).catch(function() {
      delete events[slot];
    });
    try {
      var cid = localStorage.getItem("winely_offer_ga_cid");
      if (!cid) {
        cid = Math.floor(Math.random() * 2147483647) + "." + Math.floor(Date.now() / 1e3);
        localStorage.setItem("winely_offer_ga_cid", cid);
      }
      var body = new URLSearchParams({ en: "quiz_newsletter_" + stage });
      Object.keys(payload).forEach(function(key) {
        body.set("ep." + key, String(payload[key]));
      });
      fetch("https://www.google-analytics.com/g/collect?v=2&tid=G-FX8W3687MH&cid=" + encodeURIComponent(cid), {
        method: "POST",
        body: body.toString(),
        keepalive: true
      }).catch(function() {
      });
    } catch (_) {
    }
  }
  function render(next) {
    if (!next) {
      var shared = read(uiKey);
      next = shared && (shared.state || (shared.confirmedAt ? "confirmed" : "entry")) || "entry";
      context.masked = shared && shared.masked_email || "";
      ownedToken = continuation();
      if (next !== "pending") clearInterval(timer);
    }
    state = next;
    root.dataset.quizState = state;
    root.querySelectorAll("[data-banner-card]").forEach(function(n) {
      n.hidden = n !== card;
    });
    entry.hidden = state !== "entry";
    panel.hidden = state === "entry";
    if (decor) decor.hidden = state !== "entry";
    art.hidden = state === "entry";
    if (state !== "entry") {
      art.src = state === "pending" ? art.dataset.pendingSrc : art.dataset.confirmedSrc;
      root.querySelector("[data-quiz-state-title]").textContent = text()[state + "Title"];
      root.querySelector("[data-quiz-state-copy]").textContent = text()[state + "Copy"];
    }
    root.querySelector("[data-quiz-masked-email]").textContent = context.masked || "";
    check.hidden = state !== "pending";
    updateResendButton();
    claim.hidden = state !== "confirmed" && state !== "claimed";
    claim.textContent = state === "claimed" ? text().open : text().claim;
    root.querySelector("[data-quiz-change]").textContent = text().change;
    message.textContent = "";
    if (state === "confirmed") syncClaimedFromCart();
  }
  var cartChecks = 0;
  function syncClaimedFromCart() {
    if (state !== "confirmed" || cartChecks >= 8) return;
    cartChecks++;
    var global = document.querySelector("[data-wynch-club-global]");
    var variant2 = global && global.dataset.cavaVariantId;
    if (!variant2 || typeof fetch !== "function") return;
    fetch("/cart.js", { headers: { accept: "application/json" } }).then(function(r) {
      return r.json();
    }).then(function(cart) {
      var items = cart && cart.items || [];
      var granted = items.some(function(i) {
        return String(i.variant_id) === String(variant2) && i.properties && i.properties._wynch_club_cava === "article_club" && Number(i.final_line_price) === 0 && i.quantity === 1;
      });
      if (granted) {
        if (state === "confirmed") {
          if (window.WynchClubFlowV1) window.WynchClubFlowV1.renderState({ state: "claimed" }, true, false);
          render("claimed");
        }
        return;
      }
      if (state === "confirmed") setTimeout(syncClaimedFromCart, 2e3);
    }).catch(function() {
    });
  }
  function quizId() {
    var id = null;
    try {
      id = new URLSearchParams(location.search).get("qid");
    } catch (_) {
    }
    if (!id) {
      try {
        id = localStorage.getItem("winely_qid");
      } catch (_) {
      }
    }
    return id;
  }
  function linkQuizEmailBeforeDoi(email, name, formLocale) {
    var qid = quizId();
    if (!qid) {
      if (name) {
        fetch("https://winely-backend.vercel.app/api/newsletter/name", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, first_name: name })
        }).catch(function() {
        });
      }
      return Promise.resolve();
    }
    var sessionId = null;
    try {
      sessionId = sessionStorage.getItem("winely_session_id");
    } catch (_) {
    }
    return fetch("https://winely-backend.vercel.app/api/quiz/link-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // Keep the explicit adapter marker: the shared club observer must not
      // read this identity write as a second DOI request.
      wynchClubAdapter: "explicit",
      body: JSON.stringify({
        qid,
        email,
        first_name: name || void 0,
        session_id: sessionId || void 0,
        locale: formLocale === "en" ? "en" : "de",
        accepts_marketing: false
      })
    }).then(function(response) {
      return response.json().catch(function() {
        return {};
      }).then(function(body) {
        if (!response.ok) {
          var error = new Error(body && (body.code || body.error) || "HTTP_" + response.status);
          error.status = response.status;
          error.code = body && body.code;
          throw error;
        }
        return body;
      });
    }).catch(function(error) {
      error.quizEmailLink = true;
      throw error;
    });
  }
  function continuation() {
    try {
      return localStorage.getItem("wynch_club_continuation_v1") || localStorage.getItem("wynch_article_club_continuation_v2") || "";
    } catch (_) {
      return "";
    }
  }
  function requestStatus() {
    var shared = read(uiKey);
    if (shared && (shared.confirmedAt || shared.state === "claimed")) { render(); return Promise.resolve(); }
    var token = continuation();
    if (ownedToken && token !== ownedToken) return Promise.resolve();
    if (!token || checking || busy || state === "claimed") return Promise.resolve();
    var requestGeneration = generation;
    checking = true;
    return fetch("/apps/wynch-email/status", {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json", accept: "application/json" },
      body: JSON.stringify({ contract_version: "2.0.0", continuation_token: token, locale })
    }).then(function(r) {
      if (!r.ok) throw new Error("STATUS_FAILED");
      return r.json();
    }).then(function(r) {
      if (generation !== requestGeneration || token !== continuation()) return;
      var shared = read(uiKey);
      if (shared && shared.confirmedAt) { render(); return; }
      if (r.contract_version !== "2.0.0" || ["pending", "confirmed"].indexOf(r.state) < 0) throw new Error("STATUS_INVALID");
      context.masked = r.subscriber && r.subscriber.masked_email || context.masked || "";
      save(contextKey, context);
      render(r.state);
      if (window.WynchClubFlowV1) window.WynchClubFlowV1.renderState(r, true, false);
      if (r.state === "confirmed") {
        clearInterval(timer);
        track("confirmed");
      }
    }).catch(function() {
      if (state === "pending") message.textContent = text().error;
    }).finally(function() {
      checking = false;
      updateResendButton();
    });
  }
  function remainingLabel(seconds) {
    return seconds > 90 ? Math.ceil(seconds / 60) + " min" : seconds + " s";
  }
  function updateResendButton() {
    var remaining = Math.max(0, Math.ceil(((context.resendAvailableAt || 0) - Date.now()) / 1e3));
    check.disabled = busy || remaining > 0;
    check.textContent = remaining > 0 ? text().countdown.replace("{s}", remainingLabel(remaining)) : text().check;
  }
  function startCountdown(seconds) {
    context.resendAvailableAt = Date.now() + Math.max(0, seconds) * 1e3;
    save(contextKey, context);
    clearInterval(countdownTimer);
    updateResendButton();
    countdownTimer = setInterval(function() {
      if (state !== "pending") {
        clearInterval(countdownTimer);
        return;
      }
      updateResendButton();
    }, 250);
  }
  check.addEventListener("click", function() {
    if (testing || busy || check.disabled) return;
    if (!window.WynchClubFlowV1 || typeof window.WynchClubFlowV1.resend !== "function") {
      message.textContent = text().resendError;
      return;
    }
    // Adopt the current enrollment when this tab never captured one. The guard
    // is here to stop another tab's signup taking over, not to block the tab
    // that created this one.
    var pressToken = continuation();
    if (!ownedToken) ownedToken = pressToken;
    if (pressToken !== ownedToken) return;
    busy = true;
    check.disabled = true;
    message.textContent = text().sending;
    // The runtime's resend can return a promise that never settles. Waiting on
    // it forever leaves the button disabled and the copy stuck on "sending",
    // with nothing the visitor can do, so the press gives up instead.
    var resendTimeout;
    Promise.race([
      Promise.resolve(window.WynchClubFlowV1.resend(locale)),
      new Promise(function(_, reject) {
        resendTimeout = setTimeout(function() { reject(new Error("RESEND_NO_RESPONSE")); }, 15000);
      })
    ]).then(function(result) {
      if (result.state === "entry") { render("entry"); note.hidden = false; note.textContent = text().invalid; return; }
      if (result.state === "confirmed") {
        render("confirmed");
        track("confirmed");
        return;
      }
      startCountdown(60);
      message.textContent = text().resent;
      track("resend_requested");
    }).catch(function(error) {
      var retry = error.payload && error.payload.retry_after_seconds;
      if (retry) startCountdown(retry);
      message.textContent = text().resendError;
    }).finally(function() {
      clearTimeout(resendTimeout);
      busy = false;
      updateResendButton();
    });
  });
  root.querySelector("[data-quiz-change]").addEventListener("click", function() {
    generation++;
    clearInterval(timer);
    context = {};
    try {
      var previous = read(receiptKey);
      if (previous && previous.continuationToken === ownedToken) localStorage.removeItem(receiptKey);
    } catch (_) {
    }
    save(contextKey, context);
    if (window.WynchClubFlowV1) window.WynchClubFlowV1.renderState({ state: "entry" }, true, false);
    render("entry");
    submit.disabled = false;
    form.querySelector('[name="newsletter_email"]').focus();
  });
  function poll() {
    clearInterval(timer);
    timer = setInterval(function() {
      if (document.visibilityState === "visible" && state === "pending") requestStatus();
    }, 1e4);
  }
  form.addEventListener("submit", function(event) {
    event.preventDefault();
    if (busy) return;
    var emailNode = form.querySelector('[name="newsletter_email"]');
    var language = form.querySelector('[name="newsletter_locale"]:checked');
    locale = language && language.value === "en" ? "en" : "de";
    if (!emailNode.checkValidity()) {
      note.hidden = false;
      note.textContent = text().invalid;
      emailNode.reportValidity();
      return;
    }
    generation++;
    clearInterval(timer);
    busy = true;
    submit.disabled = true;
    note.hidden = false;
    note.textContent = text().sending;
    var email = emailNode.value.trim();
    var nameNode = form.querySelector('[name="newsletter_name"]');
    var name = nameNode ? nameNode.value.trim() : "";
    var eventId = window.wynchMetaPixel ? window.wynchMetaPixel.newEventId() : null;
    track("submit_attempt");
    context = { started: Date.now(), locale, variant };
    save(contextKey, context);
    var current = new URL(location.href);
    current.searchParams.delete("quiz_bg");
    current.searchParams.delete("quiz_state");
    Promise.resolve().then(function() {
      return linkQuizEmailBeforeDoi(email, name, locale);
    }).then(function() {
      if (!window.WynchClubFlowV1) throw new Error("FLOW_UNAVAILABLE");
      var registration = window.WynchClubFlowV1.register({
        source: "quiz_results",
        channelId: "quiz_results_inline_" + locale,
        email,
        locale,
        returnPath: current.pathname + current.search + current.hash
      });
      return registration;
    }).then(function(result) {
      // The runtime writes the continuation while register() is in flight.
      // Reading it before that resolves owns nothing, and every guard below
      // then reads this tab's own enrollment as somebody else's.
      ownedToken = continuation() || ownedToken;
      context.continuation = ownedToken;
      try {
        localStorage.setItem("winely_email", email);
      } catch (_) {
      }
      if (window.wynchMetaPixel && eventId) {
        window.wynchMetaPixel.track("Lead", { content_name: "quiz_results_newsletter" }, eventId);
      }
      context.masked = result.subscriber && result.subscriber.masked_email || "";
      context.resendAvailableAt = Date.now() + 6e4;
      save(contextKey, context);
      track("submitted");
      render(result.state === "confirmed" ? "confirmed" : "pending");
      if (result.state === "confirmed") track("confirmed");
      else {
        startCountdown(60);
        poll();
      }
    }).catch(function(error) {
      context = {};
      save(contextKey, context);
      note.hidden = false;
      var reason = error && error.message;
      note.textContent = error && error.quizEmailLink ? text().linkFailed : reason === "RATE_COOLDOWN" ? text().cooldown : reason === "RATE_LIMIT" ? text().dailyLimit : text().sendError;
    }).finally(function() {
      busy = false;
      submit.disabled = false;
    });
  });
  claim.addEventListener("click", function() {
    if (state === "claimed") {
      if (window.WynchWelcomeCartV1) window.WynchWelcomeCartV1.open();
      return;
    }
    if (testing) {
      message.textContent = "Preview only \u2014 no gifts are issued.";
      return;
    }
    var shared = read(uiKey);
    if (shared && shared.confirmedAt && window.WynchClubFlowV1) {
      track("claim_clicked");
      claim.disabled = true;
      claim.textContent = text().claiming;
      window.WynchClubFlowV1.resend().catch(function() { message.textContent = text().unavailable; }).finally(function() {
        claim.disabled = false;
        claim.textContent = state === "claimed" ? text().open : text().claim;
      });
      return;
    }
    var global = document.querySelector("[data-wynch-club-global]");
    var native = global && global.querySelector("[data-club-claim-cava]");
    var status = global && global.querySelector("[data-club-cava-status]");
    if (!native || native.dataset.initialized !== "true") {
      message.textContent = text().unavailable;
      return;
    }
    if (!ownedToken || continuation() !== ownedToken) {
      message.textContent = text().error;
      return;
    }
    track("claim_clicked");
    claim.disabled = true;
    claim.textContent = text().claiming;
    var observer2 = new MutationObserver(function() {
      message.textContent = status.textContent;
      if (!native.disabled) {
        claim.disabled = false;
        claim.textContent = state === "claimed" ? text().open : text().claim;
        observer2.disconnect();
      }
    });
    observer2.observe(status, { childList: true, characterData: true, subtree: true });
    observer2.observe(native, { attributes: true, attributeFilter: ["disabled"] });
    native.click();
  });
  document.addEventListener("wynch:club-cava-verified", function() {
    render("claimed");
    claim.disabled = false;
    track("claimed");
  });
  document.addEventListener("wynch:club-offer-redeemed", function() {
    claim.disabled = true;
    message.textContent = text().unavailable;
  });
  document.addEventListener("visibilitychange", function() {
    if (document.visibilityState === "visible" && state === "pending") requestStatus();
  });
  window.addEventListener("storage", function(event) {
    if (event.key === uiKey) { render(); return; }
    if (event.key === receiptKey || event.key === "wynch_club_continuation_v1") requestStatus();
  });
  window.addEventListener("wynch:club-enrollment-registered", function(event) {
    if (!testing && event.detail && event.detail.uiOnly) { render(); if (state === "pending") poll(); }
  });
  var receipt = read(receiptKey);
  var shared = read(uiKey);
  if (testing) context = {};
  if (testing && qaState === "pending") {
    context.resendAvailableAt = Date.now() + 6e4;
    setInterval(updateResendButton, 250);
  }
  if (!testing && shared) render();
  else render(testing && qaState ? qaState : receipt || context.started ? "pending" : "entry");
  if (!testing && state === "pending" && (context.started || receipt)) {
    requestStatus();
    poll();
    startCountdown(Math.max(0, ((context.resendAvailableAt || 0) - Date.now()) / 1e3));
  }
  if (window.IntersectionObserver) {
    var observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(e) {
        return e.intersectionRatio >= 0.5;
      })) track("view");
    }, { threshold: 0.5 });
    observer.observe(card);
  }
  document.addEventListener("visitorConsentCollected", function() {
    if (card.getBoundingClientRect().top < innerHeight && card.getBoundingClientRect().bottom > 0) track("view");
  });
})();
